import { useRemoteClientGet } from '@/configs/http-client'
import { Endpoints } from '@/remote/endpoints'
import { useEffect, useState } from 'react'
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../components/ui/dialog'
import CardForm from '../forms/card-form'
//import { usePromiseToast } from '../hooks/toast-promisse';
import { Button } from '../components/ui/button'
import { ClientFormData } from '../validators/client-validator'

type DialogProps = {
  idUsuario: number
  isOpen: boolean
  type: 'ALUNO' | 'CLIENTE'
  closeDialog: () => void
  updateList?: () => void
}

export function DialogCard({ idUsuario, type, isOpen = false, closeDialog, updateList }: DialogProps) {
  const { remoteClientGet } = useRemoteClientGet()
  //const { triggerToast } = usePromiseToast();
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null | boolean>(null)
  const [data, setData] = useState<ClientFormData>()
  const isEditMode = Boolean(data?.id)

  const fetchData = async () => {
    if (!isEditMode) return

    try {
      setIsLoading(true)
      setError(false)
      const response = await remoteClientGet(`${Endpoints.card}/${idUsuario}`)
      setData(response?.data?.data)
    } catch (error) {
      //setError('Erro ao carregar os dados...');
      setError(false)
      console.error(error)
      throw error
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (isOpen) {
      //triggerToast(fetchData());
      fetchData()
    }
    console.log(idUsuario)
  }, [isOpen, idUsuario])

  return (
    <Dialog open={isOpen}>
      <DialogContent className="sm:max-w-4xl">
        <DialogHeader className="border-acelerafit-gray-dark">
          <DialogTitle className="text-acelerafit-green-300">Cartão</DialogTitle>
          <DialogDescription>{!isEditMode ? 'Edição' : 'Cadastro'}</DialogDescription>
        </DialogHeader>

        {isLoading ? (
          <div className="flex justify-center items-center p-4">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-acelerafit-green-300" />
          </div>
        ) : error ? (
          <div className="text-red-500 p-4 text-center">{error}</div>
        ) : (
          <CardForm type={type} closeDialog={closeDialog} updateList={updateList} idUsuario={idUsuario} />
        )}

        <DialogFooter className="sm:justify-end w-148">
          <Button onClick={closeDialog} className="bg-acelerafit-green-300 shadow-2xl hover:bg-acelerafit-green-300 hover:opacity-85 transition-all">
            Fechar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
